import {Injectable} from '@angular/core';

@Injectable()
export class ContractDeclinedDigitalSignatureService {
	private contractDeclinedDS = new Set<string>();

	addContractDeclinedDs(contractNumber: string) {
		this.contractDeclinedDS.add(contractNumber);
	}

	removeContractDeclinedDs(contractNumber: string) {
		this.contractDeclinedDS.delete(contractNumber);
	}

	areContractDeclinedDs(contractNumber: string): boolean {
		return this.contractDeclinedDS.has(contractNumber);
	}
}
